<div *ngIf="!showError && !pending" class="card shadow-sm p-4 mx-auto mt-5" style="max-width: 360px;">
  <div class="d-flex justify-content-end mb-3">
    <select class="lang-selector w-auto" [(ngModel)]="selectedLanguage" (change)="onLanguageChange($event.target.value)">
      <option *ngFor="let lang of languages" [value]="lang">{{lang}}</option>
    </select>
  </div>
  <img *ngIf="useCustomLogo" [src]="customLogo" alt="docquitycare" class="d-block mx-auto mb-3 tagline-logo" />
  <img *ngIf="!useCustomLogo" src="assets/images/docquitycarelogo.svg" alt="docquitycare" class="d-block mx-auto mb-3" />

  <div class="text-center mb-4">
    <h5 *ngIf="!useCustomTagline" class="fw-bold mb-2">{{ 'CHATBOT_DEFAULT_TAGLINE' | translate }}</h5>
    <h5 *ngIf="useCustomTagline" class="fw-bold mb-2">{{ pharmaTagline }}</h5>
  </div>
  <form [formGroup]="chatbotForm" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label class="form-label">{{ 'PATIENT_MOBILE' | translate }}<span class="text-danger" *ngIf="mobileIsRequired">*</span></label>
      <div class="d-flex position-relative">
        <p-dropdown
          class="d-flex align-items-center position-absolute h-100 signup-phone-code pr-2"
          [options]="countries"
          formControlName="countryCode"
          [optionLabel]="'name'"
          [optionValue]="'countryCode'">
          <ng-template pTemplate="selectedItem">
            <div class="country-item country-item-value" *ngIf="selectedCountry">
              <img [src]="selectedCountry.flag" class="flag mr-2" onerror="this.src='assets/images/logo.svg'" alt="country flag" />
              <div class="fnt-size12px text-abbey-grey mr-2 font-weight-bold">
                +{{selectedCountry.countryCode}}
              </div>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="country-item d-flex justify-content-between align-items-center p-2">
              <div class="country-item-value d-flex">
                <img [src]="item.flag" class="flag mr-2" onerror="this.src='assets/images/logo.svg'" alt="country flag" />
                <div class="fnt-size12px text-abbey-grey mr-2" [ngClass]="{'font-weight-bold': chatbotForm.get('countryCode').value === item.countryCode}">
                  {{item.name}}
                </div>
                <div class="fnt-size12px text-abbey-grey" [ngClass]="{'font-weight-bold': chatbotForm.get('countryCode').value === item.countryCode}">
                  +{{item.countryCode}}
                </div>
              </div>
              <img *ngIf="chatbotForm.get('countryCode').value === item.countryCode" src="assets/images/checkbox.svg" alt="green checked checkbox">
            </div>
          </ng-template>
        </p-dropdown>
        <input type="tel" 
               pattern="[0-9]*" 
               inputmode="numeric" 
               class="form-control signup-phone-input" 
               [placeholder]="'PATIENT_MOBILE_PLACEHOLDER' | translate" 
               formControlName="mobile" 
               maxlength="15" 
               (keypress)="onlyNumbers($event)"
               (keyup)="userInputZero('mobile', $event)" />
      </div>
      <div class="text-danger small mt-1" *ngIf="formControls.mobile.touched && formControls.mobile.invalid">
        <span *ngIf="formControls.mobile.errors?.required">{{ 'MOBILE_REQUIRED' | translate }}</span>
        <span *ngIf="formControls.mobile.errors?.pattern">{{ 'MOBILE_PATTERN_ERROR' | translate }}</span>
      </div>
    </div>
    <div class="mb-3">
      <label class="form-label">{{ 'PATIENT_EMAIL_ADDRESS' | translate }}<span class="text-danger" *ngIf="emailIsRequired">*</span></label>
      <input type="email" class="form-control" [placeholder]="'PATIENT_EMAIL_PLACEHOLDER' | translate" formControlName="email" (keypress)="preventSpace($event)" />
      <div class="text-danger small mt-1" *ngIf="formControls.email.touched && formControls.email.invalid">
        <span *ngIf="formControls.email.errors?.required">{{ 'EMAIL_REQUIRED' | translate }}</span>
        <span *ngIf="formControls.email.errors?.email">{{ 'EMAIL_PATTERN_ERROR' | translate }}</span>
      </div>
    </div>
    <div class="form-check mb-3">
      <input type="checkbox" class="form-check-input" id="consent" formControlName="consent" />
      <label for="consent" class="form-check-label">{{ 'CONSENT' | translate }}</label>
    </div>
    <button class="btn btn-dark w-100" [disabled]="chatbotForm.invalid">
      {{ 'SUBMIT_CONTINUE' | translate }}
    </button>
  </form>
</div>
<div *ngIf="showError" class="card shadow-sm bg-white text-center mx-auto mt-5" style="max-width: 360px;">
  <img src="assets/images/docquitycarelogo.svg" alt="Docquity Care" style="width: 15rem; margin-bottom: 8rem; margin-top: 2rem; margin-left: 4rem;" />
  <div>
    <img [src]="getStatusImage()" alt="Status" style="width: 80px; margin-bottom: 24px;" />
  </div>
  <h4 class="p-1" style="margin-bottom: 12px;">{{ getStatusMessage().title | translate }}</h4>
  <div class="text-gray fnt-size14px" style=" margin-bottom: 2rem; padding: 4%; color: #888;">
    {{ getStatusMessage().message | translate:getStatusMessage().params }}
  </div>
</div>
<div *ngIf="pending" class="card shadow-sm bg-white text-center mx-auto mt-5" style="max-width: 360px;">
  <img src="assets/images/docquitycarelogo.svg" alt="Docquity Care" style="width: 15rem; margin-bottom: 8rem; margin-top: 2rem; margin-left: 4rem;" />
  <div>
    <img src="assets/images/thumbs-up.svg" alt="Status" style="width: 80px; margin-bottom: 24px;" />
  </div>
  <h4 class="p-1" style="margin-bottom: 12px;">Your approval request have been sent!</h4>
  <div class="text-gray fnt-size14px" style=" margin-bottom: 2rem; padding: 4%; color: #888;">
    Our team is currently reviewing it and will get back to you shortly.
  </div>
</div>
